import ContactModule from '@features/Admin/Admin.Module';
import React from 'react';

const Contact = () => {
  return <ContactModule />;
};

export default Contact;
